import { extendTheme } from '@chakra-ui/react'

const theme = extendTheme({
  colors: {
    primary: '#002855',
    primaryHover: '#005EB8',
    secondary: '#EAAA00',
    secondaryHover: '#ED8B00',
    black: '#2C2A29',
    text: '#2d3748',
    lightgray: '#f1f1f1',
    accent: [
      'null',
      '#0033A0',
      '#9BD3DD',
      '#005EB8',
      '#0D5257',
      '#9ABEAA',
      '#ED8B00',
      '#BE3A34',
      '#CD4C08',
      '#FDDA24',
      '#657A68',
    ],
    warmgray: ['null', '#6E6259', '#7C736A', '#BFB8AF'],
  },
  fonts: {
    body: `Roboto, -apple-system, BlinkMacSystemFont,"Segoe UI",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"`,
    heading: `"EB Garamond", "Times New Roman", Times, Georgia, Cambria,  serif`,
  },
  components: {
    Button: {
      baseStyle: {
        fontFamily: 'body',
        fontWeight: 800,
        alignItems: 'center',
        textTransform: 'uppercase',
      },
      sizes: {
        md: {
          fontSize: 'sm',
        },
      },
      variants: {
        solid: {
          bg: 'primary',
          color: 'white',
          _hover: {
            bg: 'primaryHover',
          },
        },
        solid_secondary: {
          bg: 'secondary',
          color: 'white',
          _hover: {
            bg: 'secondaryHover',
          },
        },
      },
    },
  },
  styles: {
    global: {
      html: { boxSizing: 'border-box' },
      body: {
        color: 'text',
      },
      main: {
        width: 'full',
        flex: `1 1 auto`,
      },
      '[data-reach-skip-link]': {
        background: 'white',
        left: '-99999em',
        padding: '0.5em',
        position: 'absolute',
        zIndex: '1000',
        textDecoration: 'none',
      },
      '[data-reach-skip-link]:focus': {
        left: '0.5em',
        top: '0.5em',
      },
      a: {
        color: 'primary',
        textDecoration: 'underline',
      },
      p: {
        color: 'text',
        fontSize: ['md'],
        fontWeight: 400,
        mb: ['3', '3', '4'],
      },
      ul: {
        listStylePosition: 'outside',
        mb: ['3', '3', '4'],
        ml: ['6', '6', '9'],
      },
      ol: {
        listStylePosition: 'outside',
        mb: ['3', '3', '4'],
        ml: ['6', '6', '9'],
      },
      li: {
        color: 'text',
        fontSize: ['md'],
        mb: ['1', '1', '2'],
      },
      blockquote: {
        padding: 6,
        textStyle: 'italic',
        borderLeftStyle: 'solid',
        borderLeftWidth: 'thick',
        borderLeftColor: 'lightgray',
        fontSize: ['lg'],
        mb: ['3', '3', '4'],
      },
      h1: {
        fontFamily: 'heading',
        fontSize: ['4xl', '4xl', '5xl'],
        fontWeight: '400',
        lineHeight: 1.15,
      },
      h2: {
        fontFamily: 'heading',
        fontSize: ['2xl', '2xl', '3xl'],
        fontWeight: '400',
        color: 'primary',
        lineHeight: 1.25,
        mb: ['3', '3', '4'],
      },
      h3: {
        fontFamily: 'heading',
        fontSize: ['xl', 'xl', '2xl'],
        lineHeight: 1.25,
        color: 'brand.darkgrey',
        mb: ['3'],
      },
      h4: {
        fontFamily: 'heading',
        fontSize: ['lg', 'lg', 'xl'],
        lineHeight: 1,
        color: 'text',
        mb: ['2'],
      },
      h5: {
        fontSize: ['md', 'md', 'lg'],
        fontWeight: '600',
        lineHeight: 1,
        color: 'text',
        mb: ['1'],
      },
      h6: {
        fontSize: ['md', 'md', 'lg'],
        fontWeight: '600',
        lineHeight: 1,
        color: 'text',
        mb: ['1'],
      },
    },
  },
  textStyles: {
    a: {
      color: 'primary',
      textDecoration: 'underline',
    },
    p: {
      color: 'text',
      fontSize: ['md'],
      mb: ['3', '3', '4'],
    },
    ul: {
      listStylePosition: 'outside',
      mb: ['3', '3', '4'],
      ml: ['6', '6', '9'],
    },
    ol: {
      listStylePosition: 'outside',
      mb: ['3', '3', '4'],
      ml: ['6', '6', '9'],
    },
    li: {
      color: 'text',
      fontSize: ['md'],
      mb: ['1', '1', '2'],
    },
    blockquote: {
      padding: 6,
      textStyle: 'italic',
      borderLeftStyle: 'solid',
      borderLeftWidth: 'thick',
      borderLeftColor: 'lightgray',
      fontSize: ['lg'],
      mb: ['3', '3', '4'],
    },
    h1: {
      fontFamily: 'heading',
      fontSize: ['4xl', '4xl', '5xl'],
      fontWeight: '400',
      lineHeight: 1.15,
    },
    h2: {
      fontFamily: 'heading',
      fontSize: ['2xl', '2xl', '3xl'],
      fontWeight: '400',
      color: 'primary',
      lineHeight: 1.25,
      mb: ['3', '3', '4'],
    },
    h3: {
      fontFamily: 'heading',
      fontSize: ['xl', 'xl', '2xl'],
      lineHeight: 1.25,
      color: 'brand.darkgrey',
      mb: ['3'],
    },
    h4: {
      fontFamily: 'heading',
      fontSize: ['lg', 'lg', 'xl'],
      lineHeight: 1,
      color: 'text',
      mb: ['2'],
    },
    h5: {
      fontSize: ['md', 'md', 'lg'],
      fontWeight: '600',
      lineHeight: 1,
      color: 'text',
      mb: ['1'],
    },
    h6: {
      fontSize: ['md', 'md', 'lg'],
      fontWeight: '600',
      lineHeight: 1,
      color: 'text',
      mb: ['1'],
    },
  },
})

export default theme
